module.exports = __webpack_public_path__ + "img/ftp-ad.7907a002.png";